import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param data
 * @return {Promise<any>|Promise}
 */
export default (function (data) {
    var request = new Request({
        method: Methods.POST,
        url: EndPoints.RESET_PASSWORD,
        withCredentials: false,
        headers: null,
        data: data
    });
    return request.execute();
});
